// DEV-only LiDAR source choice for Road Markings Analysis (RMA).
// RMA stays one analysis type; LiDAR swaps the submitted template id.
export const RMA_SOURCES = { GOPRO: "gopro", LIDAR: "lidar" };

// The RMA task label: the key the LiDAR swap replaces in the template-id mapping.
export const RMA_TASK_LABEL = "Road Markings Analysis (RMA)";

// Template id of RMA_LIDAR.json (Drive analysis-templates folder). "" hides the option.
export const RMA_LIDAR_TEMPLATE_ID = "1lodYTv1tJodAuvMU6G1WwOc2kJXUKpHw";

export function rmaLidarAvailable(environment, lidarTemplateId) {
  return environment === "dev" && !!lidarTemplateId;
}

export function mappingForRmaSource(mapping, source, lidarTemplateId, rmaLabel) {
  const copy = { ...mapping };
  if (source === RMA_SOURCES.LIDAR && lidarTemplateId) {
    copy[rmaLabel] = lidarTemplateId;
  }
  return copy;
}

// LiDAR RMA needs no GoPro imagery, so the "RMA" imagery readiness code drops.
export function inputCodesForRmaSource(codes, source) {
  return source === RMA_SOURCES.LIDAR ? codes.filter((c) => c !== "RMA") : codes;
}

// Imagery readiness codes of `tasks` ({label: code} in `inputTaskCodes` order), for
// the chosen RMA source: the wizard checks readiness for that source only.
export function imageryCodesForTasks(tasks, inputTaskCodes, source) {
  return inputCodesForRmaSource(
    Object.keys(inputTaskCodes)
      .filter((label) => tasks.includes(label))
      .map((label) => inputTaskCodes[label]),
    source,
  );
}

// Whether a task card with imagery code `code` shows its imagery chip: never the
// RMA "GoPro video" chip on a LiDAR RMA run.
export function showsImageryChip(code, source) {
  return !!code && inputCodesForRmaSource([code], source).length > 0;
}
